export const generateRandomPastelHex = (): string => {
  const R = Math.floor((Math.random() * 127) + 127)
  const G = Math.floor((Math.random() * 127) + 127)
  const B = Math.floor((Math.random() * 127) + 127)

  const rgb = (R << 16) + (G << 8) + B

  return `#${rgb.toString(16)}`
}
